import { render, staticRenderFns } from "./SystemServerInfo.vue?vue&type=template&id=173532c6&scoped=true"
import script from "./SystemServerInfo.vue?vue&type=script&lang=js"
export * from "./SystemServerInfo.vue?vue&type=script&lang=js"
import style0 from "./SystemServerInfo.vue?vue&type=style&index=0&id=173532c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173532c6",
  null
  
)

export default component.exports